import { Button, Step, StepLabel, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductImageForm from "./ProductImageForm";
import ProductInfoForm from "./ProductInfoForm";
import ProductAdditionalInfoForm from "./ProductAdditionalInfoForm";
import ProductSubmitForm from "./ProductSubmitForm";
import { addProduct } from "../../feature/products/addProductSlice";
import { uploadProductImages } from "../../feature/products/addProductMultiImagesSlice";

const STEPS = [
  "Add Product Info",
  "Add Product Additional Info",
  "Add Product Images",
  "Submit",
];

const ProductForm = () => {
  const dispatch = useDispatch();
  const { mode } = useSelector((state) => state.mode);
  const { productId, isSuccess } = useSelector((state) => state.addProducts);
  const [activeStep, setActiveStep] = useState(0);
  const [isInputEmpty, setIsInputEmpty] = useState(false);
  const [isAdditionalEmpty, setIsAdditionalEmpty] = useState(false);

  const [productInfo, setProductInfo] = useState({
    productCategory: "",
    productName: "",
    productBrand: "",
    productAmount: "",
    productDiscountPrice: "",
    productDiscountPercentage: "",
    productImage: null,
    productTag: "",
  });
  const [additionalInfo, setAdditionalInfo] = useState({
    productDescription: "",
    productBenefits: "",
    storageAndUsage: "",
    otherProductInfo: "",
    productType: "",
    productSlug: "",
    isWeightVariable: false,
  });
  const [error, setError] = useState("");
  const [productMultiImages, setProductMultiImages] = useState([]);
  const [selectedMultiImages, setSelectedMultiImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState(null);

  const [skipped, setSkipped] = useState(new Set());

  useEffect(() => {
    if (productId !== "" && productMultiImages.length !== 0) {
      dispatch(
        uploadProductImages({ productId, productImages: productMultiImages })
      );

      setProductMultiImages([]);
      setSelectedMultiImages([]);
    }
  }, [productId, dispatch]);

  useEffect(() => {
    if (
      productInfo.productDiscountPrice !== "" &&
      productInfo.productAmount !== ""
    ) {
      let price = productInfo.productAmount;
      let discount = productInfo.productDiscountPrice;
      let discountedPrice = price - discount;

      let discountPercentage = (discountedPrice / price) * 100;

      if (discountPercentage < 0) {
        setError("Discount can not be more than Product Price");
        setProductInfo({
          ...productInfo,
          productDiscountPercentage: "",
        });
      } else {
        setError("");
        let exactDiscountPercent = Math.round(discountPercentage);
        setProductInfo({
          ...productInfo,
          productDiscountPercentage: exactDiscountPercent,
        });
      }
    } else {
      setError("");
      setProductInfo({
        ...productInfo,
        productDiscountPercentage: "",
      });
    }
  }, [
    productInfo.productAmount,
    productInfo.productDiscountPrice,
    productInfo.productDiscountPercentage,
  ]);

  // console.log("amount", productInfo.productAmount);
  // console.log("amount discount", productInfo.productDiscountPrice);

  const isStepOptional = (step) => {
    return step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  // const handleProductInfoError = () => {
  //   Object.entries(productInfo).forEach(([key, value]) => {
  //     if (value === "" || null) {
  //       setError("Please Fill all fields");
  //       return true;
  //     } else {
  //       setError("");
  //     }
  //   });
  // };
  // const checkEmptyKey = () => {
  //   Object.entries(productInfo).forEach(([key, value]) => {
  //     console.log(value);
  //   });
  // };

  // checkEmptyKey();

  const handleNext = () => {
    if (
      activeStep == 0 &&
      (productInfo.productCategory === "" ||
        productInfo.productName === "" ||
        productInfo.productBrand === "" ||
        productInfo.productAmount === "" ||
        productInfo.productDiscountPrice === "" ||
        productInfo.productTag === "" ||
        productInfo.productImage === null)
    ) {
      setIsInputEmpty(true);
      return;
    }
    if (
      activeStep == 1 &&
      (additionalInfo.productDescription === "" ||
        additionalInfo.productBenefits === "" ||
        additionalInfo.storageAndUsage === "" ||
        additionalInfo.otherProductInfo === "" ||
        additionalInfo.productType === "" ||
        additionalInfo.productSlug === "")
    ) {
      setIsAdditionalEmpty(true);
      return;
    }
    console.log("ok");

    // setIsInputEmpty(false);
    // setAdditionalInfo(false);
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleSubmit = () => {
    dispatch(addProduct({ ...productInfo, ...additionalInfo }));
    if (isSuccess) {
      setProductInfo({
        productCategory: "",
        productName: "",
        productBrand: "",
        productAmount: "",
        productDiscountPrice: "",
        productDiscountPercentage: "",
        productImage: null,
        productTag: "",
      });
      setAdditionalInfo({
        productDescription: "",
        productBenefits: "",
        storageAndUsage: "",
        otherProductInfo: "",
        productType: "",
        productSlug: "",
        isWeightVariable: false,
      });
      setSelectedImages(null);
      setActiveStep(0);
    }
  };
  const form = () => {
    if (activeStep === 0) {
      return (
        <>
          <ProductInfoForm
            productInfo={productInfo}
            setProductInfo={setProductInfo}
            selectedImages={selectedImages}
            setSelectedImages={setSelectedImages}
            error={error}
            setError={setError}
            isInputEmpty={isInputEmpty}
          />
        </>
      );
    }
    if (activeStep === 1) {
      return (
        <>
          <ProductAdditionalInfoForm
            additionalInfo={additionalInfo}
            setAdditionalInfo={setAdditionalInfo}
            isAdditionalEmpty={isAdditionalEmpty}
            setIsAdditionalEmpty={setIsAdditionalEmpty}
          />
        </>
      );
    }
    if (activeStep === 2) {
      return (
        <>
          <ProductImageForm
            productMultiImages={productMultiImages}
            setProductMultiImages={setProductMultiImages}
            selectedMultiImages={selectedMultiImages}
            setSelectedMultiImages={setSelectedMultiImages}
          />
        </>
      );
    }
    if (activeStep === 3) {
      return (
        <>
          <ProductSubmitForm
            productInfo={productInfo}
            additionalInfo={additionalInfo}
            selectedImages={selectedImages}
            selectedMultiImages={selectedMultiImages}
          />
          {/* <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button
              sx={{ color: mode === "light" ? "#000000" : "#ffffff" }}
              onClick={handleReset}
            >
              Submit
            </Button>
          </Box> */}
        </>
      );
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {STEPS.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant='caption'>Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel
                // sx={{
                //   "&.MuiStepLabel": {
                //     "&.Mui-active": {
                //       color: "red",
                //     },
                // },
                // }}
                {...labelProps}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {form()}
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          // color='inherit'
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1, color: mode === "light" ? "#000000" : "#ffffff" }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
        {isStepOptional(activeStep) && (
          <>
            <Button
              // color='inherit'
              onClick={handleSkip}
              sx={{
                mr: 1,
                color: mode === "light" ? "#000000" : "#ffffff",
              }}
            >
              Skip
            </Button>
            {/* <Button>MyButton</Button> */}
          </>
        )}

        <Button
          sx={{
            mr: 1,
            color: mode === "light" ? "#000000" : "#ffffff",
          }}
          onClick={activeStep === STEPS.length - 1 ? handleSubmit : handleNext}
        >
          {activeStep === STEPS.length - 1 ? "Submit" : "Next"}
        </Button>
      </Box>
    </Box>
  );
};
export default ProductForm;
